import { embeddingJobService } from "@/services/embeddingJobService";

/** Enqueue a topic or space semantic embedding. Membership changes must not call this. */
export function scheduleScopeEmbedding(jobType: "topic" | "space", targetId: string): void {
  const id = String(targetId || "").trim();
  if (!id) return;
  void embeddingJobService
    .enqueue([{ job_type: jobType, target_id: id }])
    .then(() => embeddingJobService.process(1))
    .catch((err) => {
      console.warn("[scope-embedding] enqueue failed", { jobType, targetId: id, err });
    });
}
